<template>
  <div>
<svg class="mr-3" width="34" height="35" viewBox="0 0 34 35" fill="none" xmlns="http://www.w3.org/2000/svg">
<ellipse cx="16.8672" cy="17.2129" rx="16.8672" ry="17.2129" fill="url(#paint0_radial_1855_4648)"/>
<path opacity="0.5" d="M0.844696 20.4402C1.05554 23.6676 3.8533 27.6745 6.58157 30.0955C9.30984 32.5165 13.0102 33.8767 16.8685 33.8767C20.7269 33.8767 24.4272 32.5165 27.1555 30.0955C29.8837 27.6745 32.8923 23.864 32.8923 20.4402C27.6558 21.8233 23.8262 16.9976 19.8203 20.4402C15.8143 23.8828 0.844696 20.4402 0.844696 20.4402Z" fill="#0000FF"/>
<path d="M32.8897 20.4402C32.6788 23.6676 29.8811 27.6745 27.1528 30.0955C24.4245 32.5165 20.7242 33.8767 16.8659 33.8767C13.0075 33.8767 9.30718 32.5165 6.57891 30.0955C3.85064 27.6745 0.842042 23.864 0.842041 20.4402C6.07855 21.8233 9.90815 16.9976 13.9141 20.4402C17.9201 23.8828 32.8897 20.4402 32.8897 20.4402Z" fill="#0000FF"/>
<defs>
<radialGradient id="paint0_radial_1855_4648" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(16.8672 17.2129) rotate(90) scale(17.2129 16.8672)">
<stop stop-color="#EAEAEE"/>
<stop offset="1" stop-color="#0000FF" stop-opacity="0.35"/>
</radialGradient>
</defs>
</svg>

    {{data.name}}
  </div>
</template>

<script>
export default {
  data() {
    return {
      data: {},
    };
  },
};
</script>

<style>
</style>